import { useEffect, useState } from "react";
import { Share, X } from "lucide-react";

import {
  isIosSafari,
  isStandalonePwa,
  shouldShowIosInstallBanner,
} from "@/lib/notifications/pwaInstall";

// ---------------------------------------------------------------------------
// IosInstallBanner (G-13) — «Zum Home-Bildschirm hinzufuegen» fuer iPhone-Safari
// ---------------------------------------------------------------------------
// Duenne, dismissbare Bar ganz oben. Nur auf iPhone-Safari, das noch NICHT als
// PWA installiert ist — denn nur dort ist Web-Push blockiert, bis der Nutzer
// «Zum Home-Bildschirm» tippt (iOS 16.4+). Einmal weggeklickt bleibt sie weg
// (localStorage). Muster: ImpersonateBar (volle Breite, border-b).

const DISMISS_KEY = "bergler.ios-install-dismissed";

function readDismissed(): boolean {
  try {
    return window.localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function IosInstallBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(
      shouldShowIosInstallBanner({
        iosSafari: isIosSafari(),
        standalone: isStandalonePwa(),
        dismissed: readDismissed(),
      }),
    );
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      // localStorage gesperrt — bleibt fuer die Session weg.
    }
    setVisible(false);
  };

  return (
    <div className="flex items-center gap-3 border-b border-border bg-surface px-4 py-2 text-2xs text-muted-foreground">
      <span className="flex-1">
        Bergler OS aufs iPhone: <Share className="inline size-3.5" /> tippen,
        dann «Zum Home-Bildschirm» — danach kommen Benachrichtigungen aufs
        Handy.
      </span>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Hinweis schliessen"
        className="shrink-0 rounded-sm p-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
